/**
 * AI 装修操作摘要：把后端返回的装修操作集逐行翻译成中文变更清单。
 * 纯逻辑模块，不依赖 Vue，便于单测。
 */
export type DecorationAiOperation = { op: string; [k: string]: unknown }

export function summarizeDecorationAiOperation(op: DecorationAiOperation): string {
  switch (op.op) {
    case 'addComponent':
      return `新增组件 ${stringValue(op.type)}`
    case 'updatePage':
      return `修改页面属性 ${patchPaths(op.patch)}`
    case 'updateComponent':
      return `修改组件 ${stringValue(op.componentId)} 的 ${patchPaths(op.patch)}`
    case 'removeComponent':
      return `删除组件 ${stringValue(op.componentId)}`
    case 'moveComponent':
      return `移动组件 ${stringValue(op.componentId)} ${directionLabel(op.direction)}`
    default:
      return `未知操作 ${op.op}`
  }
}

function stringValue(value: unknown): string {
  if (typeof value === 'string') return value
  if (value === null || value === undefined) return ''
  return String(value)
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
}

function patchPaths(patch: unknown): string {
  if (!isRecord(patch)) return ''
  return Object.keys(patch).join('、')
}

function directionLabel(direction: unknown): string {
  if (direction === 'up') return '上移'
  if (direction === 'down') return '下移'
  return stringValue(direction)
}
